import {Injectable} from '@angular/core';

const BROWSER_WINDOW = window;
const BROWSER_NAVIGATOR = navigator;
const TAB_STORAGE = sessionStorage;
const STANDALONE_QUERY = '(display-mode: standalone)';
const PWA_QUERY = /(?:^|[?&])pwa=1(?:&|$)/;
const PWA_MARKER = 'internal.pwaMode';
const ENABLED = '1';
const IOS_DEVICE = /iPad|iPhone|iPod/;

@Injectable()
export class PwaPlatform {
  get isStandalone(): boolean {
    const ios = BROWSER_NAVIGATOR as Navigator & {standalone?: boolean};
    return ios.standalone === true || !!(BROWSER_WINDOW.matchMedia && BROWSER_WINDOW.matchMedia(STANDALONE_QUERY).matches);
  }

  get isIos(): boolean { return IOS_DEVICE.test(BROWSER_NAVIGATOR.userAgent); }
  get hasModeQuery(): boolean { return PWA_QUERY.test(BROWSER_WINDOW.location.search); }

  readMode(): boolean {
    try { return TAB_STORAGE.getItem(PWA_MARKER) === ENABLED; } catch (error) { return false; }
  }

  rememberMode(): void {
    try { TAB_STORAGE.setItem(PWA_MARKER, ENABLED); } catch (error) { return; }
  }

  listen(name: string, listener: EventListener): () => void {
    BROWSER_WINDOW.addEventListener(name, listener);
    return () => BROWSER_WINDOW.removeEventListener(name, listener);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/pwa-platform.service.ts